import React from "react";
import { makeStyles, Spinner } from "@fluentui/react-components";

const useStyles = makeStyles({
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    "align-items": "center",
    backgroundColor: "#FFFFFF",
    position: "absolute",
    top: "0",
    left: "0",
    height: "100vh",
    width: "100%",
    zIndex: 9999,
  },
});

const Loader = ({ label = "Loading" }) => {
  const styles = useStyles();
  return (
    <div className={styles.spinnerContainer}>
      <Spinner appearance="primary" label={label} />
    </div>
  );
};

export default Loader;
